import moment from 'moment';

export function formatDate(dateTime) {
  if (dateTime === 'N/A') {
    return dateTime;
  }

  return moment(dateTime).format('Mo MMM YYYY');
}

export function formatDateTime(dateTime) {
  if (dateTime === 'N/A') {
    return dateTime;
  }

  return moment(dateTime).format('Mo MMM YYYY HH:mm:ss');
}
